<template>
  <div id="projects">
    <div id="all-project-wrapper" v-loading="loading">
      <div>
        <div class="tittle-total-wrapper">
          <div class="title-item">
            <div class="image-box">
              <img
                alt="二维码总量"
                class="total-icon"
                src="../../assets/images/bg/bg_all-project_qrcode_statistics.png"
              />
            </div>
            <div class="total-text-wrapper">
              <div class="total-num">
                {{ totalData.QRCodeCount }}
              </div>
              <div class="total-name">
                二维码总量
              </div>
            </div>
          </div>
          <div class="title-item">
            <div class="image-box">
              <img
                alt="项目总量"
                class="total-icon"
                src="../../assets/images/bg/bg_all-project_project_statistics.png"
              />
            </div>
            <div class="total-text-wrapper">
              <div class="total-num">
                {{ totalData.ProjectCount }}
              </div>
              <div class="total-name">
                项目总量
              </div>
            </div>
          </div>
          <div class="title-item">
            <div class="image-box">
              <img
                alt="用户数"
                class="total-icon"
                src="../../assets/images/bg/bg_all-project_user_statistics.png"
              />
            </div>
            <div class="total-text-wrapper">
              <div class="total-num">
                {{ totalData.OwnedUserCount }}
              </div>
              <div class="total-name">
                用户数
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-wrapper">
        <div class="panel__header" style="margin-top: 1em">
          <button class="qrcode_handle_btn" @click="addOrUpdateProjectModal('create', {})">
            添加项目
          </button>
        </div>
        <div class="project-item-box panel__body flex">
          <div
            v-for="(item, index) in projectStatisticList"
            :key="index"
            class="project-item"
            @click="selectProject(item)"
          >
            <el-card class="flex card-wrapper" shadow="hover">
              <div class="item-left">
                {{ item.ProjectName }}
              </div>
              <div class="item-right">
                <img
                  alt="二维码"
                  src="../../assets/images/icon/icon_table_qrcode.png"
                  style="width: 20px; height: 20px"
                />
                <div class="qrcode-num">
                  {{ item.TotalQRCodeCount }}
                </div>
              </div>
            </el-card>
            <img
              src="../../assets/images/icon/project-seting-icon.png"
              alt="设置"
              class="setting-icon pointer"
              title="设置"
              @click.stop="projectSetting(index)"
            />

            <div v-if="item.isSelect" class="update-date-list-box">
              <div class="edit" @click.stop="addOrUpdateProjectModal('update', item)">
                编辑
              </div>
              <div class="delete" @click.stop="deleteProjectModal(item.ProjectID)">
                删除
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'

let _this = void 0

export default {
  name: 'Projects',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      // 统计数据
      totalData: {},
      // 全部项目列表
      projectStatisticList: [],
      loading: false,
      imageFile: [],
    }
  },
  computed: {
    // ...mapState('', {}),
  },
  watch: {},
  created() {
    _this = this
  },
  mounted() {
    this.getQrcodeStatisticData()
    // 监听全局点击事件
    window.onclick = function monitorClick() {
      _this.inilOpinionMeu()
    }
  },
  destroy() {},
  methods: {
    ...mapMutations(['setProjectInfo', 'setRouter']),
    ...mapGetters('user', {
      getUserInfo: 'USER_INFO',
    }),
    /*
     * 添加或者编辑项目触发弹窗
     * @parma type {string} 类型 create or update
     * @parma item {object} 项目信息，如果为undefined，则为创建
     * */
    addOrUpdateProjectModal(type, item) {
      const isUpdate = type === 'update'
      this.$prompt('', isUpdate ? '编辑项目' : '创建项目', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        // 输入不为空的正则表达式
        inputPattern: /[\S]/,
        inputErrorMessage: '请输入项目名称',
        inputValue: isUpdate ? item.ProjectName : '',
        closeOnClickModal: false,
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      })
        .then(async content => {
          if (isUpdate) {
            await this.commitUpdateProject(content.value, item.ProjectID)
          } else {
            await this.commitCreateProject(content.value)
          }
        })
        .catch(() => {})
    },
    /**
     * 提交创建,项目接口
     * @param projectName {string} 项目名称
     */
    async commitCreateProject(projectName) {
      this.loading = true
      const fd = new FormData()
      fd.append('Name', projectName)
      fd.append('ID', 0)
      fd.append('upload_file', this.imageFile)
      const { success } = await this.$http({
        url: this.$api.addOrUpdateProject,
        method: 'post',
        data: fd,
      })
      if (success) {
        await this.getQrcodeStatisticData()
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '添加成功！' : '添加失败！',
      })
    },
    /**
     * 提交编辑项目接口
     * @parma projectName {string} 项目名称
     * @parma projectId {number} 项目ID
     */
    async commitUpdateProject(projectName, projectId) {
      const data = new FormData()
      data.append('Name', projectName)
      data.append('ID', projectId)
      data.append('upload_file', this.imageFile)
      const { success } = await this.$http({
        url: this.$api.updateCurrentProject,
        method: 'post',
        data,
      })
      if (success) {
        await this.getQrcodeStatisticData()
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '修改成功！' : '修改失败！',
      })
    },
    /*
     * 获取二维码统计数据
     * */
    async getQrcodeStatisticData() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getSystemOverviewStatistic,
      })
      if (success) {
        const { item } = data
        this.totalData = item
        await this.getProjectStatisticData()
      } else {
        this.loading = false
      }
    },
    /*
     * 获取项目二维码数量统计
     * */
    async getProjectStatisticData() {
      const { success, data } = await this.$http({
        url: this.$api.getProjectQRCodeOverviewStatistic,
      })
      if (success) {
        const { item } = data
        this.projectStatisticList = item.ProjectStatictisDataList ?? []
        this.loading = false
      } else {
        this.loading = false
      }
    },
    /*
     * 选择全局项目
     * @param item {object} 项目信息，
     * */
    selectProject(item) {
      const { ProjectID, ProjectName } = item
      this.setProjectInfo({ ProjectID, ProjectName })
      this.setRouter({ name: 'QRCodeManagement' })
    },
    /*
     * 点击设置按钮
     * @parma index {number} 列表索引
     * */
    projectSetting(index) {
      this.projectStatisticList[index].isSelect = true
      this.$forceUpdate()
    },
    /*
     * 点击删除按钮
     * @parma ID {number} 项目ID
     * */
    deleteProjectModal(ID) {
      this.$confirm('确定要删除这个项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'qrcode_modal_confirm_btn',
        cancelButtonClass: 'qrcode_modal_cancel_btn',
      })
        .then(async () => {
          await this.commitDeleteProject(ID)
        })
        .catch(() => {})
    },
    /*
     * 提交删除项目接口
     * @parma ID {number} 项目ID
     * */
    async commitDeleteProject(ID) {
      const { success } = await this.$http({
        url: this.$api.deleteProject,
        params: {
          projectID: ID,
        },
      })
      if (success) {
        await this.getQrcodeStatisticData()
      }
      this.$message({
        type: success ? 'success' : 'error',
        message: success ? '删除成功!' : '删除失败!',
      })
    },
    /*
     * 初始编辑，删除框的显示
     * */
    inilOpinionMeu() {
      for (const list of this.projectStatisticList) {
        list.isSelect = false
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style lang="scss" scoped>
#all-project-wrapper {
  height: 100%;
}

.tittle-total-wrapper {
  display: flex;
  align-items: center;
  height: 150px;
  padding-left: 37px;
  background: #ffffff;
  border-radius: 4px;
}

.title-item {
  display: flex;
  margin-right: 132px;
}

.image-box {
  width: 81px;
  height: 81px;
  margin-right: 15px;
}

.total-icon {
  width: 100%;
  height: 100%;
}

.total-text-wrapper {
  display: flex;
  flex-direction: column;
  height: 81px;
}

.total-num {
  font-size: 36px;
  font-weight: 700;
  flex: 2;
  color: #222222;
}

.total-name {
  font-size: 16px;
  font-weight: 700;
  flex: 1;
  color: #222222;
}

.content-wrapper {
  background: #ffffff;
  height: calc(100% - 165px);
  border-radius: 4px;
}

.add-btn-box {
  margin-top: 15px;
  padding-left: 22px;
  height: 66px;
}

.project-item-box {
  flex-wrap: wrap;
  color: #222222;
}

.project-item {
  position: relative;
  width: 344px;
  height: 79px;
  margin: 24px 41px 26px 0;
  border: 1px solid #dcdcdc;
  background: #f5f5f5;
  box-sizing: border-box;
}
.card-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #f5f5f5;
  box-sizing: border-box;
}
::v-deep .el-card__body {
  width: 100%;
  display: flex;
  padding: 0 !important;
}

.project-item:active {
  background: #ffffff;
}
.setting-icon {
  position: absolute;
  width: 14px;
  height: 14px;
  right: 8px;
  bottom: 8px;
}

.item-left {
  font-size: 16px;
  font-weight: 700;
  flex: 4;
  padding-right: 7px;
  padding-left: 24px;
  color: #222222;
}

.item-right {
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: center;
  padding-right: 26px;
  text-align: right;
}

.qrcode-num {
  margin-left: 7px;
}
.update-date-list-box {
  position: absolute;
  top: 72px;
  right: -2px;
  width: 80px;
  border: 1px solid #ebebeb;
  background-color: #ffffff;
  z-index: 1000;
  border-radius: 2px;
}
.update-date-list-box div {
  text-align: center;
  padding: 6px 15px;
  font-size: 13px;
  color: #607d88;
  cursor: pointer;
}
.update-date-list-box div:hover {
  background-color: #f5f5f5;
}
.update-date-list-box .edit {
  border-bottom: 1px solid #e1eaef;
}
.update-date-list-box .delete {
  color: #ff0000;
}
</style>
<style></style>
